import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface TipoQuejaPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface TipoQueja {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface TipoQuejaResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class TipoQuejaService {
  private readonly apiUrl = `${environment.apiUrl}/api/tipo_queja`;

  constructor(private http: HttpClient) {}

  // Listar todos los tipos de queja
  getAll(): Observable<TipoQueja[]> {
    return this.http.get<TipoQueja[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<TipoQueja> {
    return this.http.get<TipoQueja>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nuevo tipo de queja
  create(payload: TipoQuejaPayload): Observable<TipoQuejaResponse> {
    return this.http.post<TipoQuejaResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar tipo de queja
  update(id: number, payload: Partial<TipoQuejaPayload>): Observable<TipoQuejaResponse> {
    return this.http.put<TipoQuejaResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar tipo de queja (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar tipo de queja
  inactivar(id: number): Observable<TipoQuejaResponse> {
    return this.http.put<TipoQuejaResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar tipo de queja
  activar(id: number): Observable<TipoQuejaResponse> {
    return this.http.put<TipoQuejaResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}